// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.editable-text {
  position: relative;
  max-width: 100%;
  overflow: hidden;
  height: 32px;
}
.editable-text--editable,
.editable-text--editable .editable-text__text {
  cursor: pointer;
}
.editable-text__text {
  z-index: 1;
  -webkit-user-select: none;
          user-select: none;
}
.editable-text--selectable .editable-text__text {
  cursor: text;
  -webkit-user-select: text;
          user-select: text;
}
.editable-text__text,
.editable-text .editable-text__input {
  padding: 0 4px;
  margin: 0 4px;
}
.editable-text .editable-text__input {
  font-size: 18px;
  font-weight: 700;
  min-width: 124px;
  border: none;
}
.editable-text__edit-button {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  visibility: hidden;
  pointer-events: none;
}
.editable-text:hover .editable-text__edit-button,
.editable-text:focus-within .editable-text__edit-button {
  visibility: visible;
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/common/ui/editable-text/EditableText.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AASF;AAPE;;EAEE,eAAA;AASJ;AANE;EACE,UAAA;EACA,yBAAA;UAAA,iBAAA;AAQJ;AALE;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;AAOJ;AAJE;;EAEE,cAAA;EACA,aAAA;AAMJ;AAHE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAKJ;AAFE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;AAIJ;AADE;;EAEE,mBAAA;EACA,oBAAA;AAGJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.editable-text {\n  position: relative;\n  max-width: 100%;\n  overflow: hidden;\n  height: @fontSize-xxl;\n\n  &--editable,\n  &--editable &__text {\n    cursor: pointer;\n  }\n\n  &__text {\n    z-index: 1;\n    user-select: none;\n  }\n\n  &--selectable &__text {\n    cursor: text;\n    user-select: text;\n  }\n\n  &__text,\n  & &__input {\n    padding: 0 @layoutUnit-xs;\n    margin: 0 @layoutUnit-xs;\n  }\n\n  & &__input {\n    font-size: @fontSize-md;\n    font-weight: @fontWeight-bold;\n    min-width: 124px;\n    border: none;\n  }\n\n  &__edit-button {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    visibility: hidden;\n    pointer-events: none;\n  }\n\n  &:hover &__edit-button,\n  &:focus-within &__edit-button {\n    visibility: visible;\n    pointer-events: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
